export { useIsRating, useRatingMutation } from "#use-rating-mutation";
